// Detailed content for each service page, keyed by slug (exact client-provided copy).

export const serviceDetails = {
  'intermodal-transport-engineering': {
    index: '01',
    title: 'Intermodal Transport Engineering.',
    tagline: 'Technical Expertise – The Key to successful Project Execution',
    overview: [
      'Your cargo has one job: to arrive safely! Our job is to engineer everything required to make that happen. Its weight, geometry, centre of gravity, support conditions and structural limits thereby determine how it must be positioned, supported and secured throughout the journey.',
      'We convert these parameters into a complete transport concept, engineered for the forces acting throughout the journey. Load distribution, structural capacity, support arrangements and cargo securing are assessed as one integrated system. Every calculation, drawing and method statement is built around one objective: making a complex transport technically clear, practically executable and fully under control.'
    ],
    scope: [
      'Front End Engineering & Design (FEED)',
      'Stow Plans & Deck Layouts',
      'Deck Strength Analysis',
      'Load Spreading & Grillage Design',
      'Seafastening & Lashing Calculations'
    ]
  },
  'heavy-lift-engineering': {
    index: '02',
    title: 'Heavy-Lift Engineering.',
    tagline: 'Technical Expertise – The Key to successful Project Execution',
    overview: [
      'We design rigging arrangements and lifting plans that crane operators and warranty surveyors can sign off on. From single point picks to tandem crane operations with complex multi-suspension arrangements, our engineers size the material list to account for internationally recognized standards and provide step-by-step method statements. The lift plan is the operational contract – we engineer it to be defensible, executable and safe.'
    ],
    scope: [
      'Heavy-Lift Plans',
      'Rigging Design & Calculations',
      'Rigging Inspections',
      'Rigging Equipment Sourcing',
      'Crane Selection Support',
      'Risk Assessments',
      'Complete Method Statements'
    ]
  },
  'marine-survey-port-captain-services': {
    index: '03',
    title: 'Marine Survey & Port Captain Services.',
    tagline: 'Solving Technical Challenges Through Expertise & Tenacity – Peace of Mind Assured',
    overview: [
      'Our experienced marine surveyors and project cargo specialists provide independent supervision of cargo handling, lifting, lashing, transportation, and transshipment operations worldwide. Acting as the eyes and ears of our clients on-site, we verify compliance with approved procedures, identify operational risks before they escalate, and ensure that cargo, assets, and equipment are handled safely and efficiently.',
      'Through continuous monitoring, detailed inspections, and proactive communication with all stakeholders, we help prevent delays, damage, and costly disruptions. Should incidents, deviations, or non-conformities occur, they are immediately investigated, documented, and corrective actions are implemented without delay. Our independent presence provides transparency, accountability, and the technical oversight required for successful project execution.'
    ],
    scope: [
      'Cargo Condition Surveys',
      'Cargo Handling Supervision',
      'Inspection of Rigging & Seafastening',
      'Vessel & Asset Inspections',
      'Client Representation',
      'Technical Consulting'
    ]
  },
  'equipment-labor-sourcing': {
    index: '04',
    title: 'Equipment & Labor Sourcing.',
    tagline: 'Solving Technical Challenges Through Expertise & Tenacity – Peace of Mind Assured',
    overview: [
      'Every successful project cargo operation depends on having the right resources available at the right place and time. Through our network of trusted suppliers, contractors, and service providers, we source and coordinate the equipment, materials, and specialist personnel required for safe and efficient project execution. From lifting and rigging equipment to transport assets, load-spreading solutions, securing materials, and temporary works, all resources are selected to suit the specific operational requirements. In addition, we arrange for experienced specialist personnel, including stevedores, riggers, and welders, ensuring that all parties are suitably qualified and familiar with the approved operational procedures.',
      'Our involvement extends beyond procurement. We manage supplier selection, commercial negotiations, mobilization, on-site coordination, supervision, and demobilization, providing our clients with a single point of responsibility throughout the entire operation.',
      'The result is a seamless execution process where the right equipment, materials, and expertise are available when needed, reducing operational risk, avoiding costly delays, and ensuring compliance with the approved method statement.'
    ],
    scope: [
      'Lifting Gear & Rigging Equipment',
      'Weight Spread Materials',
      'Design & Fabrication of specialized Grillage',
      'Seafastening Material',
      'Stevedores (Rigging, Stowage, Lashing)',
      'Hotwork services (Welders, Cutters, NDT Inspection)'
    ]
  },
  'integrated-port-services': {
    index: '05',
    title: 'Marshalling Support for Large Scale Projects.',
    tagline: 'Streamlining Project Logistics through Expert Marshalling Services',
    overview: [
      'In today’s fast-paced industrial landscape, efficient logistics can make or break large-scale projects. Our specialized marshalling services are designed to support complex operations in sectors such as energy, infrastructure, and construction, ensuring your components and materials are in the right place at the right time – ready for deployment.'
    ],
    blocks: [
      { heading: 'Strategic Coordination & Planning', text: 'We support all aspects of logistics coordination, ensuring that every component arrives when and where it’s needed — minimizing downtime and avoiding costly delays.' },
      { heading: 'Port & Terminal Management', text: 'Utilizing key ports and terminals as marshalling yards, we efficiently help manage consolidation, inspection, and staging for onward sea or land transport.' },
      { heading: 'Rigorous Quality Control', text: 'Each item is carefully inspected and verified against specifications, ensuring everything is shipment-ready and meets quality standards.' },
      { heading: 'Transparent Documentation & Reporting', text: 'Full tracking, compliance, and reporting are integrated into every step of the process — keeping your team informed and your project on track.' }
    ],
    scope: [
      'Pre-Inspection of potential Marshalling Sites & Auditing of Marine Terminals',
      'Modelling of highly detailed Terminal Layout Plans & Gantt-Charts',
      'Planning & Supervision of Terminal Load-In / Load-Out Activities',
      'Sourcing of Cranes, SPMT, Barges, Trucks + associated Equipment',
      'Contracting of Stevedores, Welders and other relevant Services',
      'Overall Oversight of Terminal Activities (HSE Professionals, Engineers, Marine Surveyors etc.)'
    ]
  },
  'marine-logistics': {
    index: '06',
    title: 'Marine Logistics.',
    tagline: 'End-to-End Marine Transport Engineering & Execution',
    overview: [
      'Marine Logistics covers the analysis and execution of cargo movements by sea and inland waterway. We deliver motion, stability and transport analyses, plan marine routing around weather and port windows, and manage end-to-end execution from load port to discharge. Whether break-bulk, heavy-lift vessel or barge, we engineer the voyage and coordinate every interface so cargo arrives safely, on time and within its acceleration limits.'
    ],
    scope: [
      'Motion & Stability Analysis',
      'Transport Analysis',
      'Marine Routing',
      'Voyage Planning',
      'Barge & Vessel Coordination',
      'End-to-End Execution'
    ]
  }
};

export const serviceScopeIntro = "Each Intervantis engagement is delivered by experienced marine, mechanical, and offshore engineers — combining structured planning, technical analysis, and hands-on execution.";
